
import { defineComponent } from "vue";
import messages from "@/config/messages";
import { mapMutations, mapGetters } from "vuex";
import helper from "@/utils/helper";
import ConfirmationOpenEnrollmentBenefit from "./ConfirmationOpenEnrollmentBenefit.vue";

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    var enrollment = this.getEnrollment;
    this.enrollmentType = enrollment.serviceType;
    this.lastdateToEnroll = helper.formatDate(enrollment.lastDateToEnroll);
  },
  data() {
    return {
      validationMsg: "",
      isFormInvalid: false,
      enrollmentType: null,
      lastdateToEnroll: null as string | null,
    };
  },
  methods: {
    ...mapMutations(["setFormDirty"]),
    closeModal(): void {
      this.$emit("close");
    },
    async submitButton(): Promise<void> {
      this.$emit("confirmEnrollment");
    },
    reloadPage(): void {
      window.location.reload();
    },
  },
  computed: {
    ...mapGetters(["getEnrollment"]),
  },
});
